module.exports = __webpack_public_path__ + "static/media/pla_2_way_rad.9478af8f.png";